/**
 * The photography credits page.
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PhotoCredit from '../components/PhotoCredit';
import { api } from '../lib/api';

export default function Credits() {
  const { t } = useTranslation();
  const [monasteries, setMonasteries] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    api
      .monasteries({}, controller.signal)
      .then(async ({ monasteries: list }) => {
        const full = await Promise.all(list.map((m) => api.monastery(m.id, controller.signal)));
        setMonasteries(full.map((payload) => payload.monastery));
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);

  return (
    <div className="shell" style={{ paddingBlock: 'var(--space-3xl) var(--space-5xl)' }}>
      <header className="stack" style={{ marginBottom: 'var(--space-3xl)', maxWidth: '62ch' }}>
        <p className="eyebrow">{t('credits.eyebrow', 'Credits')}</p>
        <h1 className="display display--lg">{t('credits.title', 'Photography')}</h1>
        <p className="lede">
          {t(
            'credits.lede',
            'Every photograph on this site is a genuine photograph of the monastery or shrine room it depicts. We are grateful to the photographers and institutions who have made their work available.'
          )}
        </p>
        <p className="subtle">
          {t(
            'credits.serverNote',
            'Photographs are bundled and served directly to respect original licensing and fair cultural representation.'
          )}
        </p>
      </header>

      <div className="stack stack--lg">
        {monasteries.map((monastery) => (
          <section className="card card__pad" key={monastery.id}>
            <h2 style={{ fontSize: 17, marginBottom: 'var(--space-md)' }}>
              <Link to={`/monastery/${monastery.slug || monastery.id}`} style={{ color: 'inherit' }}>{monastery.name}</Link>
            </h2>
            <div className="thumbs" style={{ flexWrap: 'wrap' }}>
              {(monastery.photos || []).map((photo) => (
                <div key={photo.source} className="stack stack--sm" style={{ width: 200 }}>
                  <img src={photo.source} alt={monastery.name} loading="lazy" style={{ borderRadius: 'var(--radius-sm)', aspectRatio: '4/3', objectFit: 'cover' }} />
                  <PhotoCredit photo={photo} />
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
